import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit, FiTrash2, FiDollarSign, FiEye } from 'react-icons/fi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import ManageAmenitiesServices from './Role-based/ManageAmenitiesServices';
import { FaSearch } from 'react-icons/fa';
import { IoPricetagOutline } from 'react-icons/io5';
const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

function ManageRoomItems() {
  const [services, setServices] = useState([]);
  const [items, setItems] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [roomTypePricing, setRoomTypePricing] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchText, setSearchText] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isPricingModalOpen, setIsPricingModalOpen] = useState(false);
  const [isViewPricingModalOpen, setIsViewPricingModalOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [selectedItemPricing, setSelectedItemPricing] = useState([]);
  const [pricingData, setPricingData] = useState({
    roomtypeid: '',
    amenityitemid: '',
    custombaseprice: '',
    isavailable: true,
    displayorder: 0,
    notes: '',
  });
  const [pricingFilters, setPricingFilters] = useState({
    roomtypeid: '',
    amenityitemid: '',
  });
  const [newItem, setNewItem] = useState({
    serviceid: '',
    name: '',
    baseprice: '',
    urgentprice: '',
    price_type: 'Per item',
    showincheckin: false,
    showenhancestay: false,
    image: null,
    refundable: false,
    value: '',
    value_type: '',
    is_multi: true,
    max_quantity: 10,
  });
  const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isConfirmPricingDeleteOpen, setIsConfirmPricingDeleteOpen] = useState(false);
  const [pricingToDelete, setPricingToDelete] = useState(null);
  const [isBulkDeleteMode, setIsBulkDeleteMode] = useState(false);
  const [bulkDeleteFilters, setBulkDeleteFilters] = useState({
    roomtypeid: '',
    amenityitemid: '',
  });

  // Fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesResponse, itemsResponse, roomTypesResponse, pricingResponse] =
          await Promise.all([
            axios.get(`${BQ_BASE_URL}/bq/api/amenityservices/`),
            axios.get(`${BQ_BASE_URL}/bq/api/amenityitems/`),
            axios.get(`${BQ_BASE_URL}/bq/api/roomtypes/`),
            axios.get(`${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`),
          ]);

        setServices(servicesResponse.data);
        setItems(itemsResponse.data);

        // Log the room types response to see the structure
        console.log('Room types response:', roomTypesResponse.data);

        setRoomTypes(roomTypesResponse.data);

        // Map the pricing response to handle any data structure issues
        const pricingData = pricingResponse.data.map((pricing) => ({
          ...pricing,
          // Ensure these fields exist
          roomtypeid: pricing.roomtypeid,
          amenityitemid: pricing.amenityitemid,
          custombaseprice: pricing.custombaseprice,
          isavailable: pricing.isavailable,
          displayorder: pricing.displayorder,
          notes: pricing.notes,
        }));

        setRoomTypePricing(pricingData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching data:', err);
        setError(err.message);
        setLoading(false);
        toast.error('Failed to fetch data');
      }
    };

    fetchData();
  }, []);

  const getServiceName = (serviceId) => {
    const service = services.find((s) => s.id === serviceId);
    return service ? service.name : `Service ${serviceId}`;
  };

  const getRoomTypeName = (roomtypeid) => {
    const roomType = roomTypes.find((rt) => rt.roomtypeid === roomtypeid);
    return roomType ? roomType.roomtypename : `Room Type ${roomtypeid}`;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setNewItem((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handlePricingInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPricingData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handlePricingFilterChange = (e) => {
    const { name, value } = e.target;
    setPricingFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBulkDeleteFilterChange = (e) => {
    const { name, value } = e.target;
    setBulkDeleteFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setNewItem((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  const handlePricingClick = (item) => {
    setCurrentItem(item);
    setPricingData({
      roomtypeid: '',
      amenityitemid: item.id,
      custombaseprice: '',
      isavailable: true,
      displayorder: 0,
      notes: '',
    });
    setIsPricingModalOpen(true);
  };

  const handleViewPricingClick = async (item) => {
    try {
      setCurrentItem(item);
      const response = await axios.get(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing?amenityitemid=${item.id}`
      );
      setSelectedItemPricing(response.data);
      setIsViewPricingModalOpen(true);
    } catch (err) {
      console.error('Error fetching pricing:', err);
      toast.error('Failed to fetch room type pricing');
    }
  };

  const handleEditPricingClick = (pricing) => {
    setPricingData({
      roomtypeid: pricing.roomtypeid,
      amenityitemid: pricing.amenityitemid,
      custombaseprice: pricing.custombaseprice,
      isavailable: pricing.isavailable,
      displayorder: pricing.displayorder,
      notes: pricing.notes || '',
    });
    setCurrentItem(items.find((item) => item.id === pricing.amenityitemid));
    setIsPricingModalOpen(true);
    setIsViewPricingModalOpen(false);
  };

  const handleDeletePricingClick = (pricing) => {
    setPricingToDelete(pricing);
    setIsConfirmPricingDeleteOpen(true);
  };

  const handleDeletePricing = async () => {
    try {
      await axios.delete(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing/${pricingToDelete.roomtypeid}/${pricingToDelete.amenityitemid}`
      );

      // Refresh pricing data
      const response = await axios.get(`${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`);
      setRoomTypePricing(response.data);

      // Also refresh selected item pricing if modal is open
      if (currentItem) {
        const itemPricingResponse = await axios.get(
          `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing?amenityitemid=${currentItem.id}`
        );
        setSelectedItemPricing(itemPricingResponse.data);
      }

      toast.success('Room type pricing deleted successfully!');
      setIsConfirmPricingDeleteOpen(false);
      setPricingToDelete(null);
    } catch (err) {
      console.error('Delete pricing error:', err);
      toast.error(err.response?.data?.detail || 'Failed to delete room type pricing');
    }
  };

  const handleBulkDeletePricing = async () => {
    try {
      if (!bulkDeleteFilters.roomtypeid && !bulkDeleteFilters.amenityitemid) {
        toast.error('Please select at least one filter for bulk delete');
        return;
      }

      const params = new URLSearchParams();
      if (bulkDeleteFilters.roomtypeid) params.append('roomtypeid', bulkDeleteFilters.roomtypeid);
      if (bulkDeleteFilters.amenityitemid)
        params.append('amenityitemid', bulkDeleteFilters.amenityitemid);
      params.append('confirm', 'true');

      const response = await axios.delete(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing?${params.toString()}`
      );

      // Refresh pricing data
      const pricingResponse = await axios.get(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`
      );
      setRoomTypePricing(pricingResponse.data);

      toast.success(response.data.message || 'Bulk delete completed successfully!');
      setIsBulkDeleteMode(false);
      setBulkDeleteFilters({ roomtypeid: '', amenityitemid: '' });
    } catch (err) {
      console.error('Bulk delete error:', err);
      toast.error(err.response?.data?.detail || 'Failed to bulk delete room type pricing');
    }
  };

  const handlePricingSubmit = async (e) => {
    e.preventDefault();
    try {
      // Validate that roomtypeid is selected
      if (!pricingData.roomtypeid) {
        toast.error('Please select a room type');
        return;
      }

      // Make sure amenityitemid is set
      if (!pricingData.amenityitemid) {
        toast.error('Item ID is missing');
        return;
      }

      console.log('Submitting pricing data:', pricingData);

      const response = await axios.post(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`,
        pricingData
      );

      // Refresh pricing data
      const pricingResponse = await axios.get(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`
      );
      setRoomTypePricing(pricingResponse.data);

      toast.success(`Room type pricing ${response.data.action} successfully!`);
      setIsPricingModalOpen(false);
    } catch (err) {
      console.error('Pricing error:', err.response?.data || err.message);
      toast.error(err.response?.data?.detail || 'Failed to save room type pricing');
    }
  };

  const handlePricingUpdate = async (e) => {
    e.preventDefault();
    try {
      // Validate that roomtypeid is selected
      if (!pricingData.roomtypeid) {
        toast.error('Please select a room type');
        return;
      }

      // Find the selected room type to get its details
      const selectedRoomType = roomTypes.find(
        (rt) => rt.roomtypeid === parseInt(pricingData.roomtypeid)
      );

      if (!selectedRoomType) {
        toast.error('Selected room type not found');
        return;
      }

      console.log('Updating pricing data:', pricingData);

      const response = await axios.put(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`,
        pricingData
      );

      // Refresh pricing data
      const pricingResponse = await axios.get(
        `${BQ_BASE_URL}/bq/api/amenity-items/roomtype-pricing`
      );
      setRoomTypePricing(pricingResponse.data);

      toast.success(`Room type pricing ${response.data.action} successfully!`);
      setIsPricingModalOpen(false);
    } catch (err) {
      console.error('Pricing update error:', err.response?.data || err.message);
      toast.error(err.response?.data?.detail || 'Failed to update room type pricing');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append('serviceid', newItem.serviceid);
      formData.append('name', newItem.name);
      formData.append('baseprice', newItem.baseprice);
      formData.append('urgentprice', newItem.urgentprice);
      formData.append('price_type', newItem.price_type);
      formData.append('showincheckin', newItem.showincheckin);
      formData.append('showenhancestay', newItem.showenhancestay);
      formData.append('refundable', newItem.refundable);
      formData.append('value', newItem.value || '');
      formData.append('value_type', newItem.value_type || '');
      formData.append('is_multi', newItem.is_multi);
      formData.append('max_quantity', newItem.max_quantity);

      if (newItem.image) {
        formData.append('file', newItem.image);
      }

      const response = await axios.post(`${BQ_BASE_URL}/bq/api/amenityitems/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setItems((prev) => [...prev, response.data]);
      setIsModalOpen(false);
      setNewItem({
        serviceid: '',
        name: '',
        baseprice: '',
        urgentprice: '',
        price_type: 'Per item',
        showincheckin: false,
        showenhancestay: false,
        image: null,
        refundable: false,
        value: '',
        value_type: '',
        is_multi: true,
        max_quantity: 10,
      });
      toast.success(`Item created successfully! ID: ${response.data.id}`);
    } catch (err) {
      toast.error('Failed to create item');
    }
  };

  const handleEditClick = (item) => {
    setCurrentItem(item);
    setNewItem({
      serviceid: item.serviceid,
      name: item.name,
      baseprice: item.baseprice,
      urgentprice: item.urgentprice,
      price_type: item.price_type || 'Per item',
      showincheckin: item.showincheckin,
      showenhancestay: item.showenhancestay,
      refundable: item.refundable || false,
      value: item.value || '',
      value_type: item.value_type || '',
      is_multi: item.is_multi !== undefined ? item.is_multi : true,
      max_quantity: item.max_quantity || 10,
      image: null,
    });
    setIsEditModalOpen(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      formData.append('serviceid', newItem.serviceid);
      formData.append('name', newItem.name);
      formData.append('baseprice', newItem.baseprice);
      formData.append('urgentprice', newItem.urgentprice);
      formData.append('price_type', newItem.price_type);
      formData.append('showincheckin', newItem.showincheckin ? 'true' : 'false');
      formData.append('showenhancestay', newItem.showenhancestay ? 'true' : 'false');
      formData.append('refundable', newItem.refundable ? 'true' : 'false');
      formData.append('value', newItem.value || '');
      formData.append('value_type', newItem.value_type || '');
      formData.append('is_multi', newItem.is_multi ? 'true' : 'false');
      formData.append('max_quantity', newItem.max_quantity);

      if (newItem.image) {
        formData.append('file', newItem.image);
      }

      const response = await axios.put(
        `${BQ_BASE_URL}/bq/api/amenityitems/${currentItem.id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setItems(items.map((item) => (item.id === currentItem.id ? response.data : item)));
      setIsEditModalOpen(false);
      toast.success('Item updated successfully!');
    } catch (err) {
      toast.error('Failed to update item');
    }
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setIsConfirmDeleteOpen(true);
  };

  const handleDelete = async (itemId) => {
    try {
      const response = await axios.delete(`${BQ_BASE_URL}/bq/api/amenityitems/${itemId}`);
      setItems((prev) => prev.filter((item) => item.id !== itemId));
      toast.success(response.data.message || 'Item deleted successfully!');
    } catch (err) {
      toast.error('Failed to delete item');
    }
  };

  const filteredItems = items.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const itemsByService = services
    .map((service) => ({
      serviceName: service.name,
      items: filteredItems.filter((item) => item.serviceid === service.id),
    }))
    .filter((group) => group.items.length > 0);

  // Filter pricing based on filters
  const filteredPricing = roomTypePricing.filter((pricing) => {
    if (pricingFilters.roomtypeid && pricing.roomtypeid !== parseInt(pricingFilters.roomtypeid))
      return false;
    if (
      pricingFilters.amenityitemid &&
      pricing.amenityitemid !== parseInt(pricingFilters.amenityitemid)
    )
      return false;
    return true;
  });

  if (loading) {
    return (
      <div className="container mx-auto p-6">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-6">
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          <strong className="font-bold">Error: </strong>
          <span className="block sm:inline">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-8xl mx-auto p-6">
      <ToastContainer position="top-right" autoClose={3000} />
      <ManageAmenitiesServices />

      {/* Room Type Pricing Section */}
      <div className="mt-8 mb-8">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Room Type Pricing</h2>
          <div className="flex gap-2">
            <button
              className="bg-blue-600 text-white py-2 px-4 rounded-lg flex items-center gap-2"
              onClick={() => setIsBulkDeleteMode(true)}
            >
              <FiTrash2 className="h-5 w-5" /> Bulk Delete
            </button>
            <button
              className="bg-green-600 text-white py-2 px-4 rounded-lg flex items-center gap-2"
              onClick={() => {
                setPricingData({
                  roomtypeid: '',
                  amenityitemid: '',
                  custombaseprice: '',
                  isavailable: true,
                  displayorder: 0,
                  notes: '',
                });
                setIsPricingModalOpen(true);
              }}
            >
              <FiPlus className="h-5 w-5" /> Add Pricing
            </button>
          </div>
        </div>

        {/* Filters */}
        <div className="bg-gray-50 p-4 rounded-lg mb-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Filter by Room Type
              </label>
              <select
                name="roomtypeid"
                value={pricingFilters.roomtypeid}
                onChange={handlePricingFilterChange}
                className="w-full p-2 border rounded text-sm"
              >
                <option value="">All Room Types</option>
                {roomTypes.map((roomType) => (
                  <option key={roomType.roomtypeid} value={roomType.roomtypeid}>
                    {roomType.roomtypename}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Filter by Item</label>
              <select
                name="amenityitemid"
                value={pricingFilters.amenityitemid}
                onChange={handlePricingFilterChange}
                className="w-full p-2 border rounded text-sm"
              >
                <option value="">All Items</option>
                {items.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex items-end">
              <button
                className="bg-gray-600 text-white py-2 px-4 rounded-lg"
                onClick={() => setPricingFilters({ roomtypeid: '', amenityitemid: '' })}
              >
                Clear Filters
              </button>
            </div>
          </div>
        </div>

        {/* Pricing Table */}
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Room Type
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Item
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Custom Price
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Display Order
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Notes
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredPricing.length > 0 ? (
                  filteredPricing.map((pricing) => (
                    <tr
                      key={`${pricing.roomtypeid}-${pricing.amenityitemid}`}
                      className="hover:bg-gray-50"
                    >
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                        {getRoomTypeName(pricing.roomtypeid)}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                        {items.find((item) => item.id === pricing.amenityitemid)?.name ||
                          `Item ${pricing.amenityitemid}`}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                        {pricing.custombaseprice
                          ? `₹${parseFloat(pricing.custombaseprice).toFixed(2)}`
                          : 'Default'}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap">
                        {pricing.isavailable ? (
                          <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                            Available
                          </span>
                        ) : (
                          <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                            Unavailable
                          </span>
                        )}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                        {pricing.displayorder || 0}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 max-w-xs truncate">
                        {pricing.notes || '-'}
                      </td>
                      <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                        <div className="flex space-x-2">
                          <button
                            className="text-blue-600 hover:text-blue-900"
                            onClick={() => handleEditPricingClick(pricing)}
                            title="Edit Pricing"
                          >
                            <FiEdit className="h-4 w-4" />
                          </button>
                          <button
                            className="text-red-600 hover:text-red-900"
                            onClick={() => handleDeletePricingClick(pricing)}
                            title="Delete Pricing"
                          >
                            <FiTrash2 className="h-4 w-4" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="px-4 py-8 text-center text-sm text-gray-500">
                      No room type pricing found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <h1 className="text-2xl font-bold mt-12 mb-5">Amenity Services Items</h1>
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <div className="relative w-full md:w-1/3">
          <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
          <input
            type="text"
            placeholder="Search by items..."
            className="w-full pl-10 pr-4 py-2 border rounded-lg"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <button
          className="bg-black text-white hover:text-white py-2 px-4 rounded-lg flex items-center gap-2"
          onClick={() => {
            setNewItem({
              serviceid: '',
              name: '',
              baseprice: '',
              urgentprice: '',
              price_type: 'Per item',
              showincheckin: false,
              showenhancestay: false,
              image: null,
              refundable: false,
              value: '',
              value_type: '',
              is_multi: true,
              max_quantity: 10,
            });
            setIsModalOpen(true);
          }}
        >
          <FiPlus className="h-5 w-5" /> Create New Item
        </button>
      </div>

      {/* Create Item Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Create New Amenity Item</h2>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="serviceid"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Service Sub-Category
                    </label>
                    <select
                      id="serviceid"
                      name="serviceid"
                      value={newItem.serviceid}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    >
                      <option value="">Select a service</option>
                      {services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-4">
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                      Item Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={newItem.name}
                      onChange={handleInputChange}
                      placeholder="Enter item name here."
                      className="w-full p-2 border rounded text-sm"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="baseprice"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Base Price
                    </label>
                    <input
                      type="number"
                      id="baseprice"
                      name="baseprice"
                      value={newItem.baseprice}
                      onChange={handleInputChange}
                      placeholder="Enter Base Price here."
                      className="w-full p-2 border rounded text-sm"
                      required
                      step="0.01"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="urgentprice"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Urgent Price
                    </label>
                    <input
                      type="number"
                      id="urgentprice"
                      name="urgentprice"
                      value={newItem.urgentprice}
                      onChange={handleInputChange}
                      placeholder="Enter Urgent Price here."
                      className="w-full p-2 border rounded text-sm"
                      required
                      step="0.01"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="price_type"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Price Type
                    </label>
                    <select
                      id="price_type"
                      name="price_type"
                      value={newItem.price_type}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    >
                      <option value="Per item">Per Item</option>
                      <option value="Per person">Per Person</option>
                      <option value="Per session">Per Session</option>
                      <option value="Per day">Per Day</option>
                      <option value="Per service">Per Service</option>
                      <option value="Per night">Per Night</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label
                      htmlFor="value_type"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Value Type
                    </label>
                    <select
                      id="value_type"
                      name="value_type"
                      value={newItem.value_type}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                    >
                      <option value="">Select value type</option>
                      <option value="P">Percentage</option>
                      <option value="F">Fixed Amount</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label htmlFor="value" className="block text-gray-700 text-sm font-bold mb-2">
                      Value Amount
                    </label>
                    <input
                      type="number"
                      id="value"
                      name="value"
                      value={newItem.value}
                      onChange={handleInputChange}
                      placeholder="Enter value amount"
                      className="w-full p-2 border rounded text-sm"
                      step="0.01"
                    />
                  </div>

                  <div className="mb-4">
                    <label
                      htmlFor="max_quantity"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Max Quantity
                    </label>
                    <input
                      type="number"
                      id="max_quantity"
                      name="max_quantity"
                      value={newItem.max_quantity}
                      onChange={handleInputChange}
                      placeholder="Maximum quantity allowed"
                      className="w-full p-2 border rounded text-sm"
                      min="1"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="image" className="block text-gray-700 text-sm font-bold mb-2">
                    Item Image
                  </label>
                  <input
                    type="file"
                    id="image"
                    name="image"
                    onChange={handleFileChange}
                    className="w-full p-2 border rounded text-sm"
                  />
                </div>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">Refundable</span>
                      <p className="text-xs text-gray-500">Allow refunds for this item</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="refundable"
                        checked={newItem.refundable}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.refundable ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.refundable ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">
                        Multi-select Item
                      </span>
                      <p className="text-xs text-gray-500">Allow multiple quantities</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="is_multi"
                        checked={newItem.is_multi}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.is_multi ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.is_multi ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">
                        Show at Check-In
                      </span>
                      <p className="text-xs text-gray-500">Display to customers during check-in</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="showincheckin"
                        checked={newItem.showincheckin}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.showincheckin ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.showincheckin ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">
                        Enhance Your Stay
                      </span>
                      <p className="text-xs text-gray-500">Display during reservation</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="showenhancestay"
                        checked={newItem.showenhancestay}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.showenhancestay ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.showenhancestay ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="px-6 py-2 bg-red-500 text-sm text-white rounded hover:text-black transition duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-black text-sm text-white rounded hover:text-white transition duration-200"
                  >
                    Create Item
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Edit Item Modal */}
      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Edit Amenity Item</h2>
              <form onSubmit={handleUpdate}>
                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="serviceid"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Service Sub-Category
                    </label>
                    <select
                      id="serviceid"
                      name="serviceid"
                      value={newItem.serviceid}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    >
                      <option value="">Select a service</option>
                      {services.map((service) => (
                        <option key={service.id} value={service.id}>
                          {service.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="mb-4">
                    <label htmlFor="name" className="block text-gray-700 text-sm font-bold mb-2">
                      Item Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={newItem.name}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="baseprice"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Base Price
                    </label>
                    <input
                      type="number"
                      id="baseprice"
                      name="baseprice"
                      value={newItem.baseprice}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                      step="0.01"
                    />
                  </div>
                  <div className="mb-4">
                    <label
                      htmlFor="urgentprice"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Urgent Price
                    </label>
                    <input
                      type="number"
                      id="urgentprice"
                      name="urgentprice"
                      value={newItem.urgentprice}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                      step="0.01"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label
                      htmlFor="price_type"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Price Type
                    </label>
                    <select
                      id="price_type"
                      name="price_type"
                      value={newItem.price_type}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    >
                      <option value="Per item">Per Item</option>
                      <option value="Per person">Per Person</option>
                      <option value="Per session">Per Session</option>
                      <option value="Per day">Per Day</option>
                      <option value="Per service">Per Service</option>
                      <option value="Per night">Per Night</option>
                    </select>
                  </div>

                  <div className="mb-4">
                    <label
                      htmlFor="value_type"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Value Type
                    </label>
                    <select
                      id="value_type"
                      name="value_type"
                      value={newItem.value_type}
                      onChange={handleInputChange}
                      className="w-full p-2 border rounded text-sm"
                    >
                      <option value="">Select value type</option>
                      <option value="P">Percentage</option>
                      <option value="F">Fixed Amount</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-4">
                    <label htmlFor="value" className="block text-gray-700 text-sm font-bold mb-2">
                      Value Amount
                    </label>
                    <input
                      type="number"
                      id="value"
                      name="value"
                      value={newItem.value}
                      onChange={handleInputChange}
                      placeholder="Enter value amount"
                      className="w-full p-2 border rounded text-sm"
                      step="0.01"
                    />
                  </div>

                  <div className="mb-4">
                    <label
                      htmlFor="max_quantity"
                      className="block text-gray-700 text-sm font-bold mb-2"
                    >
                      Max Quantity
                    </label>
                    <input
                      type="number"
                      id="max_quantity"
                      name="max_quantity"
                      value={newItem.max_quantity}
                      onChange={handleInputChange}
                      placeholder="Maximum quantity allowed"
                      className="w-full p-2 border rounded text-sm"
                      min="1"
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <label htmlFor="image" className="block text-gray-700 text-sm font-bold mb-2">
                    Item Image
                  </label>
                  <input
                    type="file"
                    id="image"
                    name="image"
                    onChange={handleFileChange}
                    className="w-full p-2 border rounded text-sm"
                  />
                  {currentItem?.imageurl && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-500">Current Image:</p>
                      <img
                        src={currentItem.imageurl}
                        alt="Current item"
                        className="h-15 w-20 object-cover rounded mt-1"
                      />
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">Refundable</span>
                      <p className="text-xs text-gray-500">Allow refunds for this item</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="refundable"
                        checked={newItem.refundable}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.refundable ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.refundable ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">
                        Multi-select Item
                      </span>
                      <p className="text-xs text-gray-500">Allow multiple quantities</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="is_multi"
                        checked={newItem.is_multi}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.is_multi ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.is_multi ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">
                        Show at Check-In
                      </span>
                      <p className="text-xs text-gray-500">Display to customers during check-in</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="showincheckin"
                        checked={newItem.showincheckin}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.showincheckin ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.showincheckin ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between cursor-pointer p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">
                        Enhance Your Stay
                      </span>
                      <p className="text-xs text-gray-500">Display during reservation</p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="showenhancestay"
                        checked={newItem.showenhancestay}
                        onChange={handleInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          newItem.showenhancestay ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          newItem.showenhancestay ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3">
                  <button
                    type="button"
                    onClick={() => setIsEditModalOpen(false)}
                    className="px-6 py-2 bg-red-500 text-sm text-white rounded hover:text-black transition duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-black text-sm text-white rounded hover:text-white transition duration-200"
                  >
                    Update Item
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Room Type Pricing Modal */}
      {/* Room Type Pricing Modal */}
      {isPricingModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">
                {pricingData.roomtypeid ? 'Edit' : 'Set'} Room Type Pricing
              </h2>

              <form onSubmit={pricingData.roomtypeid ? handlePricingUpdate : handlePricingSubmit}>
                <div className="space-y-4">
                  {/* Add Item dropdown */}
                  <div>
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                      Select Item *
                    </label>
                    <select
                      name="amenityitemid"
                      value={pricingData.amenityitemid}
                      onChange={handlePricingInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    >
                      <option value="">Select an item</option>
                      {items.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name} (₹{item.baseprice})
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                      Select Room Type *
                    </label>
                    <select
                      name="roomtypeid"
                      value={pricingData.roomtypeid}
                      onChange={handlePricingInputChange}
                      className="w-full p-2 border rounded text-sm"
                      required
                    >
                      <option value="">Select a room type</option>
                      {roomTypes.map((roomType) => (
                        <option key={roomType.roomtypeid} value={roomType.roomtypeid}>
                          {roomType.roomtypename}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                      Custom Base Price *
                    </label>
                    <input
                      type="number"
                      name="custombaseprice"
                      value={pricingData.custombaseprice}
                      onChange={handlePricingInputChange}
                      placeholder="Enter custom base price"
                      className="w-full p-2 border rounded text-sm"
                      step="0.01"
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-bold mb-2">
                      Display Order
                    </label>
                    <input
                      type="number"
                      name="displayorder"
                      value={pricingData.displayorder}
                      onChange={handlePricingInputChange}
                      placeholder="Enter display order"
                      className="w-full p-2 border rounded text-sm"
                      min="0"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 text-sm font-bold mb-2">Notes</label>
                    <textarea
                      name="notes"
                      value={pricingData.notes}
                      onChange={handlePricingInputChange}
                      placeholder="Enter any notes"
                      className="w-full p-2 border rounded text-sm"
                      rows="3"
                    />
                  </div>

                  <div className="flex items-center justify-between p-3 border rounded">
                    <div>
                      <span className="block text-sm font-bold text-gray-800 mb-1">Available</span>
                      <p className="text-xs text-gray-500">
                        Make this item available for this room type
                      </p>
                    </div>
                    <div className="relative">
                      <input
                        type="checkbox"
                        name="isavailable"
                        checked={pricingData.isavailable}
                        onChange={handlePricingInputChange}
                        className="sr-only"
                      />
                      <div
                        className={`w-12 h-6 rounded-full transition-colors ${
                          pricingData.isavailable ? 'bg-black' : 'bg-gray-300'
                        }`}
                      ></div>
                      <div
                        className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
                          pricingData.isavailable ? 'translate-x-6' : ''
                        }`}
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="flex justify-end gap-3 mt-6">
                  <button
                    type="button"
                    onClick={() => setIsPricingModalOpen(false)}
                    className="px-6 py-2 bg-red-500 text-sm text-white rounded hover:text-black transition duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-black text-sm text-white rounded hover:text-white transition duration-200"
                  >
                    Save Pricing
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* View Pricing Modal */}
      {isViewPricingModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">
                Room Type Pricing for {currentItem?.name}
              </h2>

              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Room Type
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Custom Price
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Display Order
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Notes
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {selectedItemPricing.length > 0 ? (
                      selectedItemPricing.map((pricing) => (
                        <tr key={`${pricing.roomtypeid}`} className="hover:bg-gray-50">
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                            {getRoomTypeName(pricing.roomtypeid)}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                            {pricing.custombaseprice
                              ? `₹${parseFloat(pricing.custombaseprice).toFixed(2)}`
                              : 'Default'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            {pricing.isavailable ? (
                              <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                                Available
                              </span>
                            ) : (
                              <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                                Unavailable
                              </span>
                            )}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                            {pricing.displayorder || 0}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 max-w-xs truncate">
                            {pricing.notes || '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                            <div className="flex space-x-2">
                              <button
                                className="text-blue-600 hover:text-blue-900"
                                onClick={() => handleEditPricingClick(pricing)}
                                title="Edit Pricing"
                              >
                                <FiEdit className="h-4 w-4" />
                              </button>
                              <button
                                className="text-red-600 hover:text-red-900"
                                onClick={() => handleDeletePricingClick(pricing)}
                                title="Delete Pricing"
                              >
                                <FiTrash2 className="h-4 w-4" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="px-4 py-8 text-center text-sm text-gray-500">
                          No pricing found for this item
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-end mt-6">
                <button
                  type="button"
                  onClick={() => setIsViewPricingModalOpen(false)}
                  className="px-6 py-2 bg-black text-sm text-white rounded hover:text-white transition duration-200"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Bulk Delete Pricing Modal */}
      {isBulkDeleteMode && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Bulk Delete Room Type Pricing</h2>
              <p className="text-sm text-gray-600 mb-4">
                Select filters to delete multiple pricing records. This action cannot be undone.
              </p>

              <div className="space-y-4">
                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Filter by Room Type
                  </label>
                  <select
                    name="roomtypeid"
                    value={bulkDeleteFilters.roomtypeid}
                    onChange={handleBulkDeleteFilterChange}
                    className="w-full p-2 border rounded text-sm"
                  >
                    <option value="">All Room Types</option>
                    {roomTypes.map((roomType) => (
                      <option key={roomType.roomtypeid} value={roomType.roomtypeid}>
                        {roomType.roomtypename}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-bold mb-2">
                    Filter by Item
                  </label>
                  <select
                    name="amenityitemid"
                    value={bulkDeleteFilters.amenityitemid}
                    onChange={handleBulkDeleteFilterChange}
                    className="w-full p-2 border rounded text-sm"
                  >
                    <option value="">All Items</option>
                    {items.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex justify-end gap-3 mt-6">
                <button
                  type="button"
                  onClick={() => {
                    setIsBulkDeleteMode(false);
                    setBulkDeleteFilters({ roomtypeid: '', amenityitemid: '' });
                  }}
                  className="px-6 py-2 bg-gray-500 text-sm text-white rounded hover:text-white transition duration-200"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleBulkDeletePricing}
                  className="px-6 py-2 bg-red-600 text-sm text-white rounded hover:text-white transition duration-200"
                >
                  Delete Matching Records
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Delete Modal for Item */}
      {isConfirmDeleteOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
              <p>
                Are you sure you want to delete the item: <strong>{itemToDelete?.name}</strong>?
              </p>
              <p className="text-sm text-red-600 mt-2">
                This will also delete all room type pricing associated with this item.
              </p>
              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  onClick={() => setIsConfirmDeleteOpen(false)}
                  className="px-6 py-2 bg-black text-white rounded hover:text-white transition duration-200"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    handleDelete(itemToDelete.id);
                    setIsConfirmDeleteOpen(false);
                  }}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:text-black transition duration-200"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Delete Modal for Pricing */}
      {isConfirmPricingDeleteOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
            <div className="p-6">
              <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
              <p>
                Are you sure you want to delete the pricing for{' '}
                <strong>{getRoomTypeName(pricingToDelete?.roomtypeid)}</strong>?
              </p>
              <div className="flex justify-end gap-3 mt-4">
                <button
                  type="button"
                  onClick={() => {
                    setIsConfirmPricingDeleteOpen(false);
                    setPricingToDelete(null);
                  }}
                  className="px-6 py-2 bg-black text-white rounded hover:text-white transition duration-200"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleDeletePricing}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:text-black transition duration-200"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Items Table */}
      <div className="space-y-8 mt-6">
        {itemsByService.length > 0 ? (
          itemsByService.map((serviceGroup) => (
            <div
              key={serviceGroup.serviceName}
              className="bg-white rounded-lg shadow overflow-hidden"
            >
              <div className="px-4 py-2 border-b">
                <h3 className="text-lg font-medium text-black">{serviceGroup.serviceName}</h3>
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Image
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Name
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Base Price
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Urgent Price
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Price Type
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Refundable
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Max Qty
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        At Check-in
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        At Reservation
                      </th>
                      <th className="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {serviceGroup.items.map((item) => (
                      <tr key={item.id} className="hover:bg-gray-50">
                        <td className="px-2 py-4 whitespace-nowrap">
                          {item.imageurl ? (
                            <img
                              src={item.imageurl}
                              alt={item.name}
                              className="h-15 w-20 rounded-sm object-cover"
                            />
                          ) : (
                            <div className="h-14 w-20 rounded-sm bg-gray-200 flex items-center justify-center">
                              <span className="text-xs text-gray-500">No image</span>
                            </div>
                          )}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.name}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          ₹{parseFloat(item.baseprice).toFixed(2)}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          ₹{parseFloat(item.urgentprice).toFixed(2)}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.price_type || 'Per item'}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.refundable ? (
                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                              Yes
                            </span>
                          ) : (
                            <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                              No
                            </span>
                          )}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.max_quantity || 10}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.showincheckin ? (
                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                              Yes
                            </span>
                          ) : (
                            <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                              No
                            </span>
                          )}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm text-gray-900">
                          {item.showenhancestay ? (
                            <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                              Yes
                            </span>
                          ) : (
                            <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
                              No
                            </span>
                          )}
                        </td>
                        <td className="px-2 py-4 whitespace-nowrap text-sm font-medium">
                          <div className="flex space-x-2 justify-start">
                            <button
                              className="text-blue-600 hover:text-blue-900 transition-colors"
                              onClick={() => handleViewPricingClick(item)}
                              title="View Room Type Pricing"
                            >
                              <FiEye className="h-5 w-5" />
                            </button>
                            <button
                              className="text-green-600 hover:text-green-900 transition-colors"
                              onClick={() => handlePricingClick(item)}
                              title="Add Room Type Pricing"
                            >
                              <IoPricetagOutline className="h-5 w-5" />
                            </button>
                            <button
                              className="text-blue-600 hover:text-blue-900 transition-colors"
                              onClick={() => handleEditClick(item)}
                              title="Edit Item"
                            >
                              <FiEdit className="h-5 w-5" />
                            </button>
                            <button
                              className="text-red-600 hover:text-red-900 transition-colors"
                              onClick={() => handleDeleteClick(item)}
                              title="Delete Item"
                            >
                              <FiTrash2 className="h-5 w-5" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))
        ) : (
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <div className="px-6 py-4 text-center text-sm text-gray-500">
              No items found matching your search criteria
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ManageRoomItems;

// import React, { useState, useEffect } from "react";
// import { FiPlus, FiEdit, FiTrash2 } from "react-icons/fi";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
// import ManageAmenitiesServices from "./Role-based/ManageAmenitiesServices";
// import { FaSearch } from "react-icons/fa";
// const BQ_BASE_URL = process.env.REACT_APP_BQ_BASE_URL;

// function ManageRoomItems() {
//   const [services, setServices] = useState([]);
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const [searchText, setSearchText] = useState("");
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [currentItem, setCurrentItem] = useState(null);
//   const [newItem, setNewItem] = useState({
//     serviceid: "",
//     name: "",
//     baseprice: "",
//     urgentprice: "",
//     price_type: "Per item", // Added price_type with default value
//     showincheckin: false,
//     image: null,
//     showenhancestay: false,
//   });
//   const [isConfirmDeleteOpen, setIsConfirmDeleteOpen] = useState(false);
//   const [itemToDelete, setItemToDelete] = useState(null);

//   // Fetch data from API
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [servicesResponse, itemsResponse] = await Promise.all([
//           axios.get(`${BQ_BASE_URL}/bq/api/amenityservices/`),
//           axios.get(`${BQ_BASE_URL}/bq/api/amenityitems/`),
//         ]);

//         setServices(servicesResponse.data);
//         setItems(itemsResponse.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//         toast.error("Failed to fetch data");
//       }
//     };

//     fetchData();
//   }, []);

//   const getServiceName = (serviceId) => {
//     const service = services.find((s) => s.id === serviceId);
//     return service ? service.name : `Service ${serviceId}`;
//   };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setNewItem((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleFileChange = (e) => {
//     setNewItem((prev) => ({
//       ...prev,
//       image: e.target.files[0],
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();
//       formData.append("serviceid", newItem.serviceid);
//       formData.append("name", newItem.name);
//       formData.append("baseprice", newItem.baseprice);
//       formData.append("urgentprice", newItem.urgentprice);
//       formData.append("price_type", newItem.price_type); // Added price_type
//       formData.append("showincheckin", newItem.showincheckin);
//       formData.append("showenhancestay", newItem.showenhancestay);
//       if (newItem.image) {
//         formData.append("file", newItem.image);
//       }

//       const response = await axios.post(
//         `${BQ_BASE_URL}/bq/api/amenityitems/`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       setItems((prev) => [...prev, response.data]);
//       setIsModalOpen(false);
//       setNewItem({
//         serviceid: "",
//         name: "",
//         baseprice: "",
//         urgentprice: "",
//         price_type: "Per item",
//         showincheckin: false,
//         image: null,
//         showenhancestay: false,
//       });
//       toast.success(`Item created successfully! ID: ${response.data.id}`);
//     } catch (err) {
//       toast.error("Failed to create item");
//     }
//   };

//   const handleEditClick = (item) => {
//     setCurrentItem(item);
//     setNewItem({
//       serviceid: item.serviceid,
//       name: item.name,
//       baseprice: item.baseprice,
//       urgentprice: item.urgentprice,
//       price_type: item.price_type || "Per item", // Added price_type
//       showincheckin: item.showincheckin,
//       showenhancestay: item.showenhancestay,
//       image: null,
//     });
//     setIsEditModalOpen(true);
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     try {
//       const formData = new FormData();

//       formData.append("serviceid", newItem.serviceid);
//       formData.append("name", newItem.name);
//       formData.append("baseprice", newItem.baseprice);
//       formData.append("urgentprice", newItem.urgentprice);
//       formData.append("price_type", newItem.price_type); // Added price_type
//       formData.append(
//         "showincheckin",
//         newItem.showincheckin ? "true" : "false"
//       );
//       formData.append(
//         "showenhancestay",
//         newItem.showenhancestay ? "true" : "false"
//       );

//       if (newItem.image) {
//         formData.append("file", newItem.image);
//       }

//       const response = await axios.put(
//         `${BQ_BASE_URL}/bq/api/amenityitems/${currentItem.id}`,
//         formData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       setItems(
//         items.map((item) => (item.id === currentItem.id ? response.data : item))
//       );
//       setIsEditModalOpen(false);
//       toast.success("Item updated successfully!");
//     } catch (err) {
//       toast.error("Failed to update item");
//     }
//   };

//   const handleDeleteClick = (item) => {
//     setItemToDelete(item);
//     setIsConfirmDeleteOpen(true);
//   };

//   const handleDelete = async (itemId) => {
//     try {
//       const response = await axios.delete(
//         `${BQ_BASE_URL}/bq/api/amenityitems/${itemId}`
//       );
//       setItems((prev) => prev.filter((item) => item.id !== itemId));
//       toast.success(response.data.message || "Item deleted successfully!");
//     } catch (err) {
//       toast.error("Failed to delete item");
//     }
//   };

//   const filteredItems = items.filter((item) =>
//     item.name.toLowerCase().includes(searchText.toLowerCase())
//   );

//   const itemsByService = services
//     .map((service) => ({
//       serviceName: service.name,
//       items: filteredItems.filter((item) => item.serviceid === service.id),
//     }))
//     .filter((group) => group.items.length > 0);

//   if (loading) {
//     return (
//       <div className="container mx-auto p-6">
//         <div className="flex justify-center items-center h-64">
//           <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-black"></div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="container mx-auto p-6">
//         <div
//           className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
//           role="alert"
//         >
//           <strong className="font-bold">Error: </strong>
//           <span className="block sm:inline">{error}</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-8xl mx-auto p-6">
//       <ToastContainer position="top-right" autoClose={3000} />
//       <ManageAmenitiesServices />
//       <h1 className="text-2xl font-bold mt-12 mb-5">Amenity Services Items</h1>
//       <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
//         <div className="relative w-full md:w-1/3">
//           <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//           <input
//             type="text"
//             placeholder="Search by items..."
//             className="w-full pl-10 pr-4 py-2 border rounded-lg"
//             value={searchText}
//             onChange={(e) => setSearchText(e.target.value)}
//           />
//         </div>
//         <button
//           className="bg-black text-white hover:text-white py-2 px-4 rounded-lg flex items-center gap-2"
//           onClick={() => {
//             setNewItem({
//               serviceid: "",
//               name: "",
//               baseprice: "",
//               urgentprice: "",
//               price_type: "Per item",
//               showincheckin: false,
//               image: null,
//               showenhancestay: false,
//             });
//             setIsModalOpen(true);
//           }}
//         >
//           <FiPlus className="h-5 w-5" /> Create New Item
//         </button>
//       </div>

//       {/* Create Item Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
//             <div className="p-6">
//               <h2 className="text-xl font-semibold mb-4">
//                 Create New Room Service Item
//               </h2>
//               <form onSubmit={handleSubmit}>
//                 <div className="grid grid-cols-2 gap-2">
//                   <div className="mb-4">
//                     <label
//                       htmlFor="serviceid"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Service Sub-Category
//                     </label>
//                     <select
//                       id="serviceid"
//                       name="serviceid"
//                       value={newItem.serviceid}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     >
//                       <option value="">Select a service</option>
//                       {services.map((service) => (
//                         <option key={service.id} value={service.id}>
//                           {service.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="mb-4">
//                     <label
//                       htmlFor="name"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Item Name
//                     </label>
//                     <input
//                       type="text"
//                       id="name"
//                       name="name"
//                       value={newItem.name}
//                       onChange={handleInputChange}
//                       placeholder="Enter item name here."
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="grid grid-cols-2 gap-2">
//                   <div className="mb-4">
//                     <label
//                       htmlFor="baseprice"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Base Price
//                     </label>
//                     <input
//                       type="number"
//                       id="baseprice"
//                       name="baseprice"
//                       value={newItem.baseprice}
//                       onChange={handleInputChange}
//                       placeholder="Enter Base Price here."
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     />
//                   </div>
//                   <div className="mb-4">
//                     <label
//                       htmlFor="urgentprice"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Urgent Price
//                     </label>
//                     <input
//                       type="number"
//                       id="urgentprice"
//                       name="urgentprice"
//                       value={newItem.urgentprice}
//                       onChange={handleInputChange}
//                       placeholder="Enter Urgent Price here."
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     />
//                   </div>
//                 </div>

//                 {/* Added price_type dropdown */}
//                 <div className="mb-4">
//                   <label
//                     htmlFor="price_type"
//                     className="block text-gray-700 text-sm font-bold mb-2"
//                   >
//                     Price Type
//                   </label>
//                   <select
//                     id="price_type"
//                     name="price_type"
//                     value={newItem.price_type}
//                     onChange={handleInputChange}
//                     className="w-full p-2 border rounded text-sm"
//                     required
//                   >
//                     <option value="Per item">Per Item</option>
//                     <option value="Per person">Per Person</option>
//                     <option value="Per session">Per Session</option>
//                     <option value="Per day">Per Day</option>
//                     <option value="Per service">Per Service</option>
//                     <option value="Per night">Per Night</option>
//                   </select>
//                 </div>

//                 <div className="mb-4">
//                   <label
//                     htmlFor="image"
//                     className="block text-gray-700 text-sm font-bold mb-2"
//                   >
//                     Item Image
//                   </label>
//                   <input
//                     type="file"
//                     id="image"
//                     name="image"
//                     onChange={handleFileChange}
//                     className="w-full p-2 border rounded text-sm"
//                   />
//                 </div>

//                 <div className="mb-4">
//                   <label className="flex items-center justify-between cursor-pointer">
//                     <div>
//                       <span className="block text-sm font-bold text-gray-800 mb-1">
//                         Visible to Customers at Check-In
//                       </span>
//                       <p className="text-xs text-gray-500">
//                         Toggle this ON to display this item to customers during
//                         the check-in process.
//                       </p>
//                     </div>
//                     <div className="relative">
//                       <input
//                         type="checkbox"
//                         name="showincheckin"
//                         checked={newItem.showincheckin}
//                         onChange={handleInputChange}
//                         className="sr-only"
//                       />
//                       <div
//                         className={`w-12 h-6 rounded-full transition-colors ${
//                           newItem.showincheckin ? "bg-black" : "bg-gray-300"
//                         }`}
//                       ></div>
//                       <div
//                         className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
//                           newItem.showincheckin ? "translate-x-6" : ""
//                         }`}
//                       ></div>
//                     </div>
//                   </label>
//                 </div>

//                 <div className="mb-6">
//                   <label className="flex items-center justify-between cursor-pointer">
//                     <div>
//                       <span className="block text-sm font-bold text-gray-800 mb-1">
//                         Enhance Your Stay Feature
//                       </span>
//                       <p className="text-xs text-gray-500">
//                         Toggle this item should be visible to customers during
//                       reservation.
//                       </p>
//                     </div>
//                     <div className="relative">
//                       <input
//                         type="checkbox"
//                         name="showenhancestay"
//                         checked={newItem.showenhancestay}
//                         onChange={handleInputChange}
//                         className="sr-only"
//                       />
//                        <div
//                         className={`w-12 h-6 rounded-full transition-colors ${
//                           newItem.showenhancestay ? "bg-black" : "bg-gray-300"
//                         }`}
//                       ></div>
//                       <div
//                         className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
//                           newItem.showenhancestay ? "translate-x-6" : ""
//                         }`}
//                       ></div>
//                     </div>
//                   </label>
//                 </div>

//                 <div className="flex justify-end gap-3">
//                   <button
//                     type="button"
//                     onClick={() => setIsModalOpen(false)}
//                     className="px-6 py-2 bg-red-500 text-sm text-white rounded hover:text-black transition duration-200"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="px-6 py-2 bg-black text-sm text-white rounded hover:text-white transition duration-200"
//                   >
//                     Create Item
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Edit Item Modal */}
//       {isEditModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
//             <div className="p-6">
//               <h2 className="text-xl font-semibold mb-4">
//                 Edit Room Service Item
//               </h2>
//               <form onSubmit={handleUpdate}>
//                 <div className="grid grid-cols-2 gap-2">
//                   <div className="mb-4">
//                     <label
//                       htmlFor="serviceid"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Service Sub-Category
//                     </label>
//                     <select
//                       id="serviceid"
//                       name="serviceid"
//                       value={newItem.serviceid}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     >
//                       <option value="">Select a service</option>
//                       {services.map((service) => (
//                         <option key={service.id} value={service.id}>
//                           {service.name}
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                   <div className="mb-4">
//                     <label
//                       htmlFor="name"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Item Name
//                     </label>
//                     <input
//                       type="text"
//                       id="name"
//                       name="name"
//                       value={newItem.name}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     />
//                   </div>
//                 </div>
//                 <div className="grid grid-cols-2 gap-2">
//                   <div className="mb-4">
//                     <label
//                       htmlFor="baseprice"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Base Price
//                     </label>
//                     <input
//                       type="number"
//                       id="baseprice"
//                       name="baseprice"
//                       value={newItem.baseprice}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     />
//                   </div>
//                   <div className="mb-4">
//                     <label
//                       htmlFor="urgentprice"
//                       className="block text-gray-700 text-sm font-bold mb-2"
//                     >
//                       Urgent Price
//                     </label>
//                     <input
//                       type="number"
//                       id="urgentprice"
//                       name="urgentprice"
//                       value={newItem.urgentprice}
//                       onChange={handleInputChange}
//                       className="w-full p-2 border rounded text-sm"
//                       required
//                     />
//                   </div>
//                 </div>

//                 {/* Added price_type dropdown */}
//                 <div className="mb-4">
//                   <label
//                     htmlFor="price_type"
//                     className="block text-gray-700 text-sm font-bold mb-2"
//                   >
//                     Price Type
//                   </label>
//                   <select
//                     id="price_type"
//                     name="price_type"
//                     value={newItem.price_type}
//                     onChange={handleInputChange}
//                     className="w-full p-2 border rounded text-sm"
//                     required
//                   >
//                     <option value="Per item">Per Item</option>
//                     <option value="Per person">Per Person</option>
//                     <option value="Per session">Per Session</option>
//                     <option value="Per day">Per Day</option>
//                     <option value="Per service">Per Service</option>
//                     <option value="Per night">Per Night</option>
//                   </select>
//                 </div>

//                 <div className="mb-4">
//                   <label
//                     htmlFor="image"
//                     className="block text-gray-700 text-sm font-bold mb-2"
//                   >
//                     Item Image
//                   </label>
//                   <input
//                     type="file"
//                     id="image"
//                     name="image"
//                     onChange={handleFileChange}
//                     className="w-full p-2 border rounded text-sm"
//                   />
//                   {currentItem?.imageurl && (
//                     <div className="mt-2">
//                       <p className="text-sm text-gray-500">Current Image:</p>
//                       <img
//                         src={currentItem.imageurl}
//                         alt="Current item"
//                         className="h-15 w-20 object-cover rounded mt-1"
//                       />
//                     </div>
//                   )}
//                 </div>
//                 <div className="mb-4">
//                   <label className="flex items-center justify-between cursor-pointer">
//                     <div>
//                       <span className="block text-sm font-bold text-gray-800 mb-1">
//                         Visible to Customers at Check-In
//                       </span>
//                       <p className="text-xs text-gray-500">
//                         Toggle this ON to display this item to customers during
//                         the check-in process.
//                       </p>
//                     </div>
//                     <div className="relative">
//                       <input
//                         type="checkbox"
//                         name="showincheckin"
//                         checked={newItem.showincheckin}
//                         onChange={handleInputChange}
//                         className="sr-only"
//                       />
//                       <div
//                         className={`w-12 h-6 rounded-full transition-colors ${
//                           newItem.showincheckin ? "bg-black" : "bg-gray-300"
//                         }`}
//                       ></div>
//                       <div
//                         className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
//                           newItem.showincheckin ? "translate-x-6" : ""
//                         }`}
//                       ></div>
//                     </div>
//                   </label>
//                 </div>

//                 <div className="mb-6">
//                   <label className="flex items-center justify-between cursor-pointer">
//                     <div>
//                       <span className="block text-sm font-bold text-gray-800 mb-1">
//                         Enhance Your Stay Feature
//                       </span>
//                       <p className="text-xs text-gray-500">
//                         Toggle this item should be visible to customers during
//                         reservation.
//                       </p>
//                     </div>
//                     <div className="relative">
//                       <input
//                         type="checkbox"
//                         name="showenhancestay"
//                         checked={newItem.showenhancestay}
//                         onChange={handleInputChange}
//                         className="sr-only"
//                       />
//                      <div
//                         className={`w-12 h-6 rounded-full transition-colors ${
//                           newItem.showenhancestay ? "bg-black" : "bg-gray-300"
//                         }`}
//                       ></div>
//                       <div
//                         className={`dot absolute left-1 top-1 w-4 h-4 rounded-full bg-white transition-transform ${
//                           newItem.showenhancestay ? "translate-x-6" : ""
//                         }`}
//                       ></div>
//                     </div>
//                   </label>
//                 </div>

//                 <div className="flex justify-end gap-3">
//                   <button
//                     type="button"
//                     onClick={() => setIsEditModalOpen(false)}
//                     className="px-6 py-2 bg-red-500 text-sm text-white rounded hover:text-black transition duration-200"
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     className="px-6 py-2 bg-black text-sm text-white rounded hover:text-white transition duration-200"
//                   >
//                     Update Item
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Confirmation Delete Modal */}
//       {isConfirmDeleteOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
//           <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
//             <div className="p-6">
//               <h2 className="text-xl font-semibold mb-4">Confirm Deletion</h2>
//               <p>
//                 Are you sure you want to delete the item:{" "}
//                 <strong>{itemToDelete?.name}</strong>?
//               </p>
//               <div className="flex justify-end gap-3 mt-4">
//                 <button
//                   type="button"
//                   onClick={() => setIsConfirmDeleteOpen(false)}
//                   className="px-6 py-2 bg-black text-white rounded hover:text-white transition duration-200"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   onClick={() => {
//                     handleDelete(itemToDelete.id);
//                     setIsConfirmDeleteOpen(false);
//                   }}
//                   className="px-6 py-2 bg-red-500 text-white rounded hover:text-black transition duration-200"
//                 >
//                   Delete
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Items Table */}
//       <div className="space-y-8 mt-6">
//         {itemsByService.length > 0 ? (
//           itemsByService.map((serviceGroup) => (
//             <div
//               key={serviceGroup.serviceName}
//               className="bg-white rounded-lg shadow overflow-hidden"
//             >
//               <div className="px-4 py-2 border-b">
//                 <h3 className="text-lg font-medium text-black">
//                   {serviceGroup.serviceName}
//                 </h3>
//               </div>
//               <div className="overflow-x-auto">
//                 <table className="min-w-full divide-y divide-gray-200">
//                   <thead className="bg-gray-50">
//                     <tr>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Image
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Name
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Base Price
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Urgent Price
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Price Type
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Show in Check-in
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Enhance Stay
//                       </th>
//                       <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                         Actions
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody className="bg-white divide-y divide-gray-200">
//                     {serviceGroup.items.map((item) => (
//                       <tr key={item.id} className="hover:bg-gray-50">
//                         <td className="px-4 py-4 whitespace-nowrap">
//                           {item.imageurl ? (
//                             <img
//                               src={item.imageurl}
//                               alt={item.name}
//                               className="h-15 w-20 rounded-sm object-cover"
//                             />
//                           ) : (
//                             <div className="h-14 w-20 rounded-sm bg-gray-200 flex items-center justify-center">
//                               <span className="text-xs text-gray-500">
//                                 No image
//                               </span>
//                             </div>
//                           )}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {item.name}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
//                           ₹{item.baseprice.toFixed(2)}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
//                           ₹{item.urgentprice.toFixed(2)}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {item.price_type || "Per item"}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {item.showincheckin ? (
//                             <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
//                               Yes
//                             </span>
//                           ) : (
//                             <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
//                               No
//                             </span>
//                           )}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-900">
//                           {item.showenhancestay ? (
//                             <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
//                               Yes
//                             </span>
//                           ) : (
//                             <span className="px-2 py-1 bg-red-100 text-red-800 rounded-full text-xs">
//                               No
//                             </span>
//                           )}
//                         </td>
//                         <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
//                           <div className="flex space-x-4 justify-start">
//                             <button
//                               className="text-blue-600 hover:text-blue-900 transition-colors"
//                               onClick={() => handleEditClick(item)}
//                             >
//                               <FiEdit className="h-5 w-5" />
//                             </button>
//                             <button
//                               className="text-red-600 hover:text-red-900 transition-colors"
//                               onClick={() => handleDeleteClick(item)}
//                             >
//                               <FiTrash2 className="h-5 w-5" />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="bg-white rounded-lg shadow overflow-hidden">
//             <div className="px-6 py-4 text-center text-sm text-gray-500">
//               No items found matching your search criteria
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default ManageRoomItems;
